// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadScreen_wrapper__1Nzfw","logo":"LoadScreen_logo__NE1Iv","message":"LoadScreen_message__224e8","spinner":"LoadScreen_spinner__2XDPs AuthController_spinner__1yaT3"};